import $ from 'jquery';

export default function () {

    $(window).on('scroll', function handleScroll() {

        const fromTop = $('body').offset().top;

        const fromHero = $('body').offset().top + 100;

        if ($(window).scrollTop() > fromTop) {

            $('.js-header').addClass('scrolling');

        } else {

            $('.js-header').removeClass('scrolling');

        }

        if ($(window).scrollTop() > 0) {

            $('.js-header').addClass('stick');

            $('body').addClass('is-header-stick');

        } else {

            $('.js-header').removeClass('stick');

            $('body').removeClass('is-header-stick');

        }

    });
}
